import { LOCALES } from 'fractals'

export const SEO_TITLE = {
  [LOCALES.en]: 'Information article | Journal MITM.Institute',
  [LOCALES.ru]: 'Информационная статья | Журнал MITM.Institute',
  [LOCALES.uz]: `Ma'lumot maqola | MITM.Institute jurnali`,
  [LOCALES.kk]: 'Aqparattıq maqala | MITM.Institute jwrnalı'
} as const

export const SEO_DESCRIPTION = {
  [LOCALES.ru]:
    'Статья блога онлайн-института МИТМ. Читайте самые свежие публикации по актуальным темам: психология, дизайн, маркетинг, строительство, менеджмент, экономика, образование и многое другое.',
  [LOCALES.en]:
    'Blog article of the online institute MITM. Read the latest publications on current topics: psychology, design, marketing, construction, management, economics, education and much more.',
  [LOCALES.uz]: `MITM onlayn institutining blog maqolasi. Joriy mavzulardagi so'nggi nashrlarni o'qing: psixologiya, dizayn, marketing, qurilish, menejment, iqtisodiyot, ta'lim va boshqalar.`,
  [LOCALES.kk]:
    'MITM onlayn ïnstïtwtınıñ blog maqalası. Ağımdağı taqırıptar boyınşa soñğı jarïyalanımdardı oqıñız: psïxologïya, dïzayn, marketïng, qurılıs, menedjment, ékonomïka, bilim jäne t.b.'
} as const
